import React, { useState } from 'react';
import Earning from '../../common/Earning';
import Payment from '../../common/Payment';
import MyFund from '../../common/MyFund';
import MetaTags from 'react-meta-tags';
import './performance.css';
import Form from 'react-bootstrap/Form';
import currency from 'currency.js';
import PageHeader from '../../common/PageHeader';
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, Tab, Tabs } from '@mui/material';
import { PerformanceContext } from '../../common/PUHomepage/PerformanceWidget/PerformanceContext';

const Performance = () => {
    const [fundTotal, setFundTotal] = useState(0);
    const [viewType, setViewType] = useState('summary');
    const [subscriptionTotal, setSubscriptionTotal] = useState(0);
    const [tipsTotal, setTipsTotal] = useState(0);
    const [ppvTotal, setPpvTotal] = useState(0);
    const [referralTotal, setReferralTotal] = useState(0);
    const [chargebackTotal, setChargebackTotal] = useState(0);
    const [activeTab, setActiveTab] = useState('my-funds');
    const [period, setPeriod] = useState('14_DAYS');
    const [total, setTotal] = useState(0);

    const handleChange = (e, value) => {
        setActiveTab(value);
    };

    const handlePeriodChange = (e) => {
        setPeriod(e.target.value);
    };

    return (
        <div className="container mb-4">
            <MetaTags>
                <title>Performance &#8211; Best way to make money as an influencer for your exclusive content</title>
                <meta name="description" content="Privaposts is a social media platform that lets influencers make money from their followers by keeping exclusive content hidden until a monthly subscription price has been paid." />
            </MetaTags>
            <PageHeader title='Performance' />
            <div className="performance-tabbed-content">

            <Tabs
                value={activeTab}
                onChange={handleChange}
                sx={{
                    '& .Mui-selected': {
                        color: '#0097fe !important'
                    }
                }}
                variant="fullWidth"
                centered
            >
                <Tab
                    value="earnings"
                    icon={<i className="fa-sharp fa-regular fa-coins"></i>}
                    label="Earnings"
                    iconPosition="start"
                />
                <Tab
                    icon={<i className="fa-solid fa-wallet"></i>}
                    value="payments"
                    label="Payments"
                    iconPosition="start"
                />
                <Tab
                    icon={<i className="fa-solid fa-hand-holding-circle-dollar"></i>}
                    value="my-funds"
                    label="My Funds"
                    iconPosition="start"
                />
            </Tabs>
            {/* Contents */}
            {
                activeTab !== 'my-funds'
                    && <div className='period-options-container'>
                        <div style={{ fontSize: '14px' }}>
                            <strong>Total for period {currency(total).format({ precision: 2 })}</strong>
                        </div>
                        <div>
                            <FormControl sx={{ m: 1, minWidth: 80 }}>
                                <InputLabel
                                    id="period"
                                >Select Period</InputLabel>
                                <Select
                                    value={period}
                                    size="small"
                                    onChange={handlePeriodChange}
                                    input={<OutlinedInput label="Select Period" size='small' />}
                                    labelId="period"
                                    // id="earnings-period-autowidth"
                                    id="period-autowidth"
                                    autoWidth
                                >
                                    <MenuItem value="1_HR">1 Hour</MenuItem>
                                    <MenuItem value="24_HRS">24 Hours</MenuItem>
                                    <MenuItem value="7_DAYS">7 Days</MenuItem>
                                    {/* <MenuItem value="1_MONTH">1 Month</MenuItem> */}
                                    <MenuItem value="14_DAYS">14 Days</MenuItem>
                                    <MenuItem value="ALL_TIME">All Time</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
            }

            {
                activeTab === 'my-funds'
                    ? <div className='my-funds'>
                        <div className="ml-4 my-2" style={{ fontWeight: 'bold' }}>
                            <Form.Check
                                type="radio"
                                label="Summary"
                                inline
                                onClick={() => setViewType('summary')}
                                defaultChecked
                                name="viewType"
                            />
                            <Form.Check
                                type="radio"
                                label="Details"
                                inline
                                name="viewType"
                                onClick={() => setViewType('details')}
                            />
                        </div>

                        <div className="summary-earning-table-container">
                            <MyFund
                                setTotal={setFundTotal}
                                setSubscriptionTotal={setSubscriptionTotal}
                                subscriptionTotal={subscriptionTotal}
                                setTipsTotal={setTipsTotal}
                                tipsTotal={tipsTotal}
                                setPpvTotal={setPpvTotal}
                                ppvTotal={ppvTotal}
                                setReferralTotal={setReferralTotal}
                                referralTotal={referralTotal}
                                setChargebackTotal={setChargebackTotal}
                                chargebackTotal={chargebackTotal}
                                viewType={viewType}
                                fundTotal={fundTotal}
                            />
                        </div>
                    </div>
                    : (
                        activeTab === 'payments'
                            ? <div className="performance-table-container">
                                {/* <Payment /> */}
                                <PerformanceContext.Provider value={{ period, setTotal }}>
                                    <div style={{
                                        // maxHeight: 'calc(100vh - 550px)',
                                        // overflow: 'auto'
                                    }}>
                                        <Payment />
                                    </div>
                                </PerformanceContext.Provider>
                            </div>
                            : (
                                activeTab === 'earnings'
                                    ? <div className="performance-table-container">
                                        {/* <Earning /> */}
                                        <PerformanceContext.Provider value={{ period, setTotal }}>
                                            <div style={{
                                                // maxHeight: 'calc(100vh - 550px)',
                                                // overflow: 'auto'
                                            }}>
                                                <Earning />
                                            </div>
                                        </PerformanceContext.Provider>
                                    </div>
                                    : null
                            )
                    )
            }
            </div>
        </div>
    );
};

export default Performance;
